export default __webpack_public_path__ + "static/media/neighborhood.69bce3c4.jpeg";